import {
  GET_CURRENT_USER_BEGIN,
  GET_CURRENT_USER_SUCCESS,
  SET_OFFERING_CLASS,
  SET_OFFERING_MODEL,
  SET_ASSET_CLASS_SEARCH,
} from "./actions";

export default function reducer(state, action) {
  if (action.type === GET_CURRENT_USER_BEGIN) {
    return { ...state, userLoading: true };
  }
  if (action.type === GET_CURRENT_USER_SUCCESS) {
    return {
      ...state,
      userLoading: false,
      user: action.payload.user,
    };
  }
  if (action.type === SET_OFFERING_MODEL) {
    return { ...state, offeringModel: action.payload.offeringModel };
  }
  if (action.type === SET_OFFERING_CLASS) {
    return { ...state, offeringClass: action.payload.offeringClass };
  }
  if (action.type === SET_ASSET_CLASS_SEARCH) {
    return { ...state, assetClassSearch: action.payload.assetClassSearch };
  }

  throw new Error(`no such action: ${action.type}`);
}
